/* eslint-disable no-restricted-imports */
import { useMemo } from 'react';
import { getStoreDataByPhysicalStoreId } from '@/data/utils/commonIntegrationUtils';

export const usePhysicalStoreData = ({ physicalStoreId }: { physicalStoreId: string }) =>
	useMemo(() => getStoreDataByPhysicalStoreId(physicalStoreId), [physicalStoreId]);
